    <template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Consumption Report</h2>
             <!-- <button type="reset" @click="printBarcode" class="btn b-light btn-danger-light btn-sm">Barcode</button> -->
        </div>



        <!-- Filter Form -->
      <!-- Filter Form -->
<div class="card p-4 mb-4">
    <form @submit.prevent="filterPurchases">
        <!-- Flex container with responsive adjustments -->
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center sm:space-y-0 sm:space-x-4">



        <!-- Branch Name Filter -->
        <div class="w-full sm:w-auto select2-container sm:ml-0  ml-3">
            <label for="branch_name" class="block text-sm font-medium text-gray-700">Branch Name</label>
            <select class="w-full form-input"   id="branch_name" ref="branchName" v-model="sale.branchid">
                <option value=""></option>
                <option value="All">All</option>
                <option v-for="(item, index) in branchList" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
        </div>

            <!-- Plot Name Filter -->
            <div class="w-full sm:w-auto select2-container sm:ml-0 ml-3">
                <label for="plot_name" class="block text-sm font-medium text-gray-700">Plot Name</label>
                <select class="w-full form-input" id="plot_name" ref="plotName" v-model="sale.plotid">
                    <option value=""></option>
                    <option value="All">All</option>
                    <option v-for="(item, index) in filteredPlotList" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
            </div>




            <!-- Date Filters -->
            <div class="w-full sm:w-auto sm:ml-0  ml-2">
                <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                <input type="date" id="startDate" v-model="startDate" class="w-full sm:w-auto p-2 border border-gray-300 rounded" />
            </div>
            <div class="w-full sm:w-auto sm:ml-0  ml-2">
                <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                <input type="date" id="endDate" v-model="endDate" class="w-full sm:w-auto p-2 border border-gray-300 rounded" />
            </div>

            <!-- Submit Button -->
            <div class="w:150px sm:w-auto sm:ml-0  ml-3">
                <button type="submit" class="btn b-solid btn-primary-solid w-full sm:w-auto px-5 cursor-pointer mt-4 sm:mt-6">Filter</button>
            </div>

        </div>
    </form>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center sm:space-y-0 sm:space-x-4">
            <!-- Product Name Filter -->
            <div class="w-full sm:w-auto select2-container">
                <label for="product_name" class="block text-sm font-medium text-gray-700">Product Name</label>
                <select class="w-full form-input" id="prod_name" ref="productName" v-model="sale.prodname">
                    <option value=""></option>
                    <option value="All">All</option>
                    <option v-for="(item, index) in productLists" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
            </div>

            <div class="w-full sm:w-auto select2-container ml-3">
                <label for="emp_name" class="block text-sm font-medium text-gray-700">Employee Name</label>
                <select class="w-full form-input" id="emp_name" ref="employeeName" v-model="sale.empname">
                    <option value=""></option>
                    <option value="All">All</option>
                    <option v-for="(item, index) in emplist" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            </div>



   
</div>

        

            <div class="card">
                <!-- Static heading -->
                <div id="printable-content">
                    <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                    <h1 class="print-only" style="text-align: center;">Consumption Report</h1>
                </div>

                <button
                    type="reset"
                    @click="printReceipt"
                    class="btn b-light btn-danger-light btn-sm"
                >
                    Print
                </button> &nbsp;&nbsp;&nbsp;
                     <button @click="exportToExcel" class="btn b-light btn-primary-light btn-sm">
                    Export
                </button> 

                </div>

                <div class="printonly">
                    From {{startDate}} To {{endDate}}
                </div>



            <!-- Loading Spinner -->
            <div v-if="isLoading" class="flex justify-center items-center h-32">
                <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Data is Loading...</span>
                </div>
            </div>


        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full" v-if="isTableVisible">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                       
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Employee Name</th> 
                                    <th class="bg-[#B2E8D9]">Plot Name</th> 
                                    <th class="bg-[#B2E8D9]">Branch Name</th> 
                                    <th class="bg-[#B2E8D9]">Product Name</th>
                                    <!--<th class="bg-[#B2E8D9]">Taaki</th>-->
                                    <!--<th class="bg-[#B2E8D9]">Gher</th>-->
                                    <!--<th class="bg-[#B2E8D9]">Res</th>-->
                                    <!--<th class="bg-[#B2E8D9]">pressure</th>-->
                                    <!--<th class="bg-[#B2E8D9]">fan</th>-->
                                    <!--<th class="bg-[#B2E8D9]">ghan</th>-->
                                    <th class="bg-[#B2E8D9]">Qty</th>

                                 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in filteredProductsList" :key="item.id"> 
                                    <td>{{item.entry_date}}</td>
                                    <td>{{item.emp_name}}</td>
                                    <td>{{item.plot_name}}</td> 
                                    <td>{{item.branch_name}}</td> 
                                    <td>{{item.product_name}}</td>
                                    <!--<td>{{item.taaki}}</td>-->
                                    <!--<td>{{item.gher}}</td>-->
                                    <!--<td>{{item.res}}</td>-->
                                    <!--<td>{{item.pressure}}</td>-->
                                    <!--<td>{{item.fan}}</td>-->
                                    <!--<td>{{item.ghan}}</td>-->
                                    <td>{{item.qty+' '+((item.product_unit)?item.product_unit:'')}}</td>

                             
                                </tr> 
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="5" class="font-bold text-right">Total:</td>
                                    <td class="font-bold">{{ totalQuantity }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
       
 
       
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
    
    
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';
import BarcodeComp from '@/components/BarcodeComp.vue'

export default {
name: 'AddProduct',
components: {
 BarcodeComp
} ,
mounted(){
 this.getBasics();



},
watch: {
     filteredProductsList() {
       
        
              this.$nextTick(() => {
                $('#basicDataTable').DataTable({
                  // Optional: Add your DataTable options here
                  responsive: true,
                  destroy: true,
                });
              }); 
        },
     },
data() {
    const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
 return {
     isBarcodePrint:false,
     stockSummary: [], // Holds the parsed Excel data
    file: null ,
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
      startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
      endDate: today,
      isTableVisible: false, // Initially table is hidden
    // startDate:'', 
    // endDate:'',  
     productsList:[],
     original_plotList:[],
     custName: '',
     filteredProductsList:[],
     origial_productsList:[],
     sale: {
            // branchid: null,
            sale:'',
            prodname:'',
            custName:'',
            branchid:'',
            plotid:'',
            prodname:'',
            empname:'',


        },
     branchList:[],
     emplist:[],
     all_branchList_List:[],

     productLists:[],
     all_productLists_Lists:[],
     filteredPlotList:[],
     filteredProductsList: [],
     origial_productsList:[],
     original_productsList:[],
     isLoading: false, // Flag for loading spinner
     datatable:null,
    //  product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
   // product:{productid:'',manufacturingdate:'',expirydate:'',batchno:'',openingstock:'',quantity:''},
   products:{name:'',content:'',description:'',purchaserate:''},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 }, 

 computed: {
                totalQuantity() {
                const total = this.filteredProductsList.reduce((total, item) => total + (parseFloat(item.qty) || 0), 0);
                return parseFloat(total.toFixed(2));
            }

    },

methods:{

    exportToExcel() {
        // Prepare the CSV header
        const headers = ["entry_date", "emp_name", "plot_name", "branch_name","product_name","taaki","ghe","re","qty"];
        const rows = this.filteredProductsList.map(item => [
            item.entry_date,
            item.emp_name,
            item.plot_name,
            item.branch_name,
            item.product_name,
            item.taaki,
            item.ghe,
            item.re,
            item.qty,
        ]);

        // Combine headers and rows into a CSV string
        const csvContent = [headers, ...rows]
            .map(row => row.map(value => `"${value}"`).join(","))
            .join("\n");

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Trigger a download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "consumption_report.csv");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },


        async getBasics() {
            this.isLoading = true;
            var self = this;
            axios.post('getConsumptionBasicsFilterData').then(function (response) {
                self.branchList = response.data.branchlist;
                self.original_plotList =  response.data.plotlist;
                

            }).catch(error => {
                console.error('Error fetching data', error);
            })
            .finally(() => {
                this.isLoading = false;
            })
            
            
            .then(() => {


                $("#branch_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        //alert(event.target.value);
                                             self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                        //     self.filteredProductsList.slice(0); 
                                            if(event.target.value>0) {
                                                self.filteredPlotList=self.original_plotList.filter(item => item.branchid === event.target.value);
                                            }else{
                                                self.filteredPlotList=self.original_plotList;
                                            }
                                            $("#plot_name").select2({
                                                width: '100%',
                                                dropdownAutoWidth : true,
                                                placeholder:"Search Plot Here...",
                                             }).on('change', function (event) {
                                                  self.sale.plotid=event.target.value; 
                                             });
                                        //  $('.datatable').DataTable().destroy();
                                        });


                                   











                                        $("#prod_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Product Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        //alert(event.target.value);
                                         self.sale.plotid=event.target.value; 
                                            //self.productsList.slice(0); 
                                        //     self.filteredProductsList.slice(0);
                                        //     if(event.target.value>0) { 
                                        //         self.filteredProductsList=self.original_productsList.filter(item => item.prdid === event.target.value);
                                        // }else{
                                        //     self.filteredProductsList=self.original_productsList;
                                        // }

                                       // $('.datatable').DataTable().destroy();

                                        });
                                        
                                    




            $("#emp_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Employee Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        //alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                        //     self.filteredProductsList.slice(0);
                                        //      if(event.target.value>0) { 
                                        //         self.filteredProductsList=self.original_productsList.filter(item => item.empid === event.target.value);
                                        //  }else{
                                        //      self.filteredProductsList=self.original_productsList;
                                        //  }

                                      //  $('.datatable').DataTable().destroy();

                                        });
                                

            

                                    }).finally(function () {
                                        self.isLoading = false; // Hide the spinner after the request

            });







        },

        printReceipt() {
            $('#basicDataTable').DataTable().destroy(); 
             window.print();
    },

        
        filterPurchases() {
            this.isLoading = true;
            var self = this;
            axios.post('getConsumptionBasics',{fromdate:self.startDate,todate:self.endDate,branchid:this.sale.branchid,plotid:this.sale.plotid}).then(function (response) {
                if ($.fn.dataTable.isDataTable('#basicDataTable')) {
                    $('#basicDataTable').DataTable().destroy();
                }
                                              
                self.productsList = response.data.products;
                self.filteredProductsList = self.productsList;
                // self.branchList = response.data.branchlist;
                // self.plotList = response.data.plotlist;
                self.original_plotList = self.plotList;
                self.productLists = response.data.productss;
                self.emplist = response.data.emplist;                


                self.original_productsList = response.data.products;
                self.isTableVisible=true;
              
             
           

            }).catch(error => {
                console.error('Error fetching data', error);
            })
            .finally(() => {
                this.isLoading = false;
            })
            
            
            .then(() => {

 




                                        $("#prod_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Product Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        //alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                             if ($.fn.dataTable.isDataTable('#basicDataTable')) {
                                                     $('#basicDataTable').DataTable().destroy();
                                                  }
              
                                            self.filteredProductsList.slice(0);
                                            if(event.target.value>0) { 
                                                self.filteredProductsList=self.original_productsList.filter(item => item.prdid === event.target.value);
                                        }else{
                                            self.filteredProductsList=self.original_productsList;
                                        }

                                       

                                        });
                                        
                                    




            $("#emp_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Employee Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        //alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                             if ($.fn.dataTable.isDataTable('#basicDataTable')) {
                                                 $('#basicDataTable').DataTable().destroy();
                                              }
                                            self.filteredProductsList.slice(0);
                                            // if(event.target.value>0) { 
                                                self.filteredProductsList=self.original_productsList.filter(item => (""+item.empid).split(',').includes(event.target.value));
                                        // }else{
                                        //     self.filteredProductsList=self.original_productsList;
                                        // }

                                         
                                        });
                                

            

                                    }).finally(function () {
                                        self.isLoading = false; // Hide the spinner after the request

            });







        },





        
}
}
</script>
<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
            display: block; 
        }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>